// BEGIN: popup-shipping-insurance.js

document.addEventListener('DOMContentLoaded', function() {
  // 1. Grab references to checkout and popup elements
  const originalCheckoutButton = document.querySelector('#custom-cart-checkout');

  const popupOverlay          = document.getElementById('popup-overlay');
  const popupTitle            = document.getElementById('popup-title'); // optional title
  const insuranceText         = document.getElementById('insurance-text');
  const signatureText         = document.getElementById('signature-text');
  const proceedCheckoutButton = document.getElementById('proceed-checkout-button');
  const closePopupButton      = document.getElementById('close-popup-button');
  const extraInsuranceNote    = document.getElementById('extra-insurance-note');
  const extraSignatureNote    = document.getElementById('extra-signature-note');

  // NEW: Instead of "Add" buttons, we have checkboxes for Insurance & Signature
  const insuranceCheckbox     = document.getElementById('insurance-checkbox');
  const signatureCheckbox     = document.getElementById('signature-checkbox');

  // "Remove Signature" button from your HTML (if you still have it somewhere)
  const removeSignatureButton = document.getElementById('remove-signature-button');

  // 2. Variant IDs (replace these with your real IDs)
  const SHIPPING_INSURANCE_VARIANT_ID = 40306027724949; 
  const SIGNATURE_VARIANT_ID          = 42642778652821; 

  let operationPending = false;
  let checkoutNavigating = false;
  let popupOpening = false;
  let popupOpener = null;
  let previousOverflow = '';

  async function requestJson(url, options) {
    const response = await fetch(url, options);
    const data = await response.json().catch(() => null);
    if (!response.ok || !data || typeof data !== 'object' || data.status >= 400 || data.errors) {
      throw new Error(data?.description || data?.message || window.cartStrings.error);
    }
    return data;
  }

  async function readCart() {
    const cart = await requestJson('/cart.js');
    if (!Array.isArray(cart.items) || !Number.isInteger(cart.item_count) || !Number.isInteger(cart.total_price) ||
        cart.items.some(item => !Number.isInteger(item.quantity) || !Number.isInteger(item.line_price))) throw new Error(window.cartStrings.error);
    return cart;
  }

  function merchandiseTotal(cart) {
    const addonTotal = cart.items.reduce((total, item) => {
      return [SHIPPING_INSURANCE_VARIANT_ID, SIGNATURE_VARIANT_ID].includes(Number(item.variant_id))
        ? total + item.line_price : total;
    }, 0);
    return Math.max(0, cart.total_price - addonTotal) / 100;
  }

  function reportError(error) {
    console.error(error);
    if (error.membershipCode) window.VibeadMembership.report(error);
    else if (typeof showWarning === 'function') showWarning(error.message || window.cartStrings.error);
  }

  function setBusy(busy, checkout = false) {
    [proceedCheckoutButton, closePopupButton, insuranceCheckbox, signatureCheckbox, removeSignatureButton].forEach(element => {
      if (element) element.disabled = busy;
    });
    popupOverlay?.setAttribute('aria-busy', String(busy));
    proceedCheckoutButton?.setAttribute('aria-busy', String(busy && checkout));
  }

  function closePopup() {
    if (popupOverlay) popupOverlay.style.display = 'none';
    document.body.style.overflow = previousOverflow;
    if (popupOpener?.isConnected) popupOpener.focus();
    else document.getElementById('custom-cart-checkout')?.focus();
  }

  popupOverlay?.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      event.preventDefault();
      if (!operationPending) closePopupButton?.click();
    }
    if (event.key !== 'Tab') return;
    const focusable = [...popupOverlay.querySelectorAll('button, input, a[href], [tabindex="0"]')]
      .filter(element => !element.disabled && element.getClientRects().length);
    const first = focusable[0], last = focusable[focusable.length - 1];
    if (!first) { event.preventDefault(); return; }
    if (event.shiftKey && (document.activeElement === first || !focusable.includes(document.activeElement))) {
      event.preventDefault(); last.focus();
    } else if (!event.shiftKey && (document.activeElement === last || !focusable.includes(document.activeElement))) {
      event.preventDefault(); first.focus();
    }
  });

  // 3. Intercept original cart checkout button => show popup
  if (originalCheckoutButton) {
    originalCheckoutButton.addEventListener('click', function(event) {
      event.preventDefault();
      showPopup();
    });
  }

  // -------------------------------------------
  // SHOW POPUP
  // -------------------------------------------
  function showPopup() {
    const insuranceWrapper = document.getElementById('insurance-wrapper');
    const insuranceCheckbox = document.getElementById('insurance-checkbox');
    const insuranceText = document.getElementById('insurance-text');
    if (popupOpening || operationPending) return;
    popupOpening = true;
    popupOpener = document.activeElement;
    window.VibeadMembership.checkout()
      .then(({ cart }) => {
        const cartTotal    = merchandiseTotal(cart);
        const insuranceQty = calculateInsuranceQty(cartTotal);

        // Hide entire insurance UI if insuranceQty=0
        if (insuranceQty === 0) {
          if (insuranceWrapper) insuranceWrapper.style.display = 'none';
          if (insuranceText) insuranceText.style.display = 'none';
          if (insuranceCheckbox) insuranceCheckbox.style.display = 'none';
          if (popupTitle) popupTitle.textContent = "Would you like to add a Delivery Signature option?";
          
          // Hide the extra-insurance-note
          if (extraInsuranceNote) {
            extraInsuranceNote.style.display = 'block';
            extraInsuranceNote.style.color = '#000';
            extraInsuranceNote.innerHTML = `
              <div>
                <ul style="list-style: none; margin: 0; padding: 0; padding: 0; text-align: left;"">
                  <li style="margin-bottom: 1em; display: flex;">
                    <span style="color: #00ad00; font-size: 20px; font-weight: bold; margin-right: 10px;">&#10003;</span>
                    <div>
                      <span style="font-weight: 500">Extra security</span> ensuring peace of mind.
                    </div>
                  </li>
                  <li style="margin-bottom: 1em; display: flex;">
                    <span style="color: #00ad00; font-size: 20px; font-weight: bold; margin-right: 10px;">&#10003;</span>
                    <div>
                      <span style="font-weight: 500">Signature option</span> adds an extra layer of protection against 'Porch Pirates'.
                    </div>
                  </li>
                </ul>
              </div>
            `;
          }
        } else {
          // Show shipping insurance UI
          if (insuranceWrapper) insuranceWrapper.style.display = '';
          if (insuranceText)     insuranceText.style.display    = 'block';
          if (insuranceCheckbox) insuranceCheckbox.style.display = 'inline-block';
          if (popupTitle) popupTitle.textContent = "Would you like to add additional Shipping Insurance or a Delivery Signature option?";
          
          // Show insurance cost
          const insuranceUnitPrice = 3.00;
          const insuranceTotal     = insuranceUnitPrice * insuranceQty;
          if (insuranceText) {
            insuranceText.textContent = `Shipping Insurance: $${insuranceTotal.toFixed(2)}`;
          }

          // Default note text if not added (just an example)
          if (extraInsuranceNote) {
            extraInsuranceNote.style.display = 'block';
            extraInsuranceNote.style.color = '#000';
            extraInsuranceNote.innerHTML = `
              <div>
                <ul style="list-style: none; margin: 0; padding: 0; text-align: left;">
                  <li style="margin-bottom: 1em; display: flex;">
                    <span style="color: #00ad00; font-size: 20px; font-weight: bold; margin-right: 10px;">&#10003;</span>
                    <div>
                      <span style="font-weight: 500">Extra security</span> ensuring peace of mind.
                    </div>
                  </li>
                  <li style="margin-bottom: 1em; display: flex;">
                    <span style="color: #00ad00; font-size: 20px; font-weight: bold; margin-right: 10px;">&#10003;</span>
                    <div>
                      <span style="font-weight: 500">Affordable coverage</span> at $3 per additional $100 of coverage above the initial $100.
                    </div>
                  </li>
                  <li style="margin-bottom: 1em; display: flex;">
                    <span style="color: #00ad00; font-size: 20px; font-weight: bold; margin-right: 10px;">&#10003;</span>
                    <div>
                      <span style="font-weight: 500">Worry-free shopping</span> knowing your order is covered for loss or damage during transit.
                    </div>
                  </li>
                  <li style="margin-bottom: 1em; display: flex;">
                    <span style="color: #00ad00; font-size: 20px; font-weight: bold; margin-right: 10px;">&#10003;</span>
                    <div>
                      <span style="font-weight: 500">Signature option</span> adds an extra layer of protection against 'Porch Pirates'.
                    </div>
                  </li>
                </ul>

                <p style="color: #dc3545; font-size: 11px; font-weight: 500; line-height: 16px; margin-top: 20px;">
                  <span style="font-weight: 500;">Important:</span> Canada Post Expedited Parcel and Xpresspost shipments within Canada include up to $100 in coverage for loss or damage during transit, subject to Canada Post’s terms and exclusions. 
                </p>
              </div>
            `;
          }
        }

        // Check if insurance already in cart => checkbox checked
        const insuranceItem = cart.items.find(
          item => item.variant_id === SHIPPING_INSURANCE_VARIANT_ID
        );
        if (insuranceItem && insuranceCheckbox) {
          insuranceCheckbox.checked = true;
          // Optionally tweak note color if item is in cart
          if (extraInsuranceNote) {
            extraInsuranceNote.style.color   = '#000';
            extraInsuranceNote.innerHTML = `
              <span style="color: #00ad00; font-size: 20px; font-weight: bold; margin-right: 10px;">&#10003;</span>
              <span>Your order is insured for any loss or damages incurred during transit.</span>
              <p style="font-size: 12px; color: #dc3545; font-weight: 500;">
                Your shipping insurance may have been adjusted to match your cart total.
              </p>
            `;
          }
        } else if (insuranceQty > 0 && insuranceCheckbox) {
          insuranceCheckbox.checked = false;
        }

        // Check if signature already in cart => checkbox checked
        const signatureItem = cart.items.find(
          item => item.variant_id === SIGNATURE_VARIANT_ID
        );
        if (signatureItem && signatureCheckbox) {
          signatureCheckbox.checked = true;
          // Show signature note
          if (extraSignatureNote) {
            extraSignatureNote.style.display = 'block';
            extraSignatureNote.innerHTML = '<span style="font-weight: 500;">Notice</span>: Please ensure someone will be home to sign when your order arrives.';
          }
        } else if (signatureCheckbox) {
          signatureCheckbox.checked = false;
          // Hide signature note if not in cart
          if (extraSignatureNote) extraSignatureNote.style.display = 'none';
        }

        // Show popup overlay
        previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        if (popupOverlay) {
          popupOverlay.style.display = 'flex';
          popupOverlay.querySelector('.popup-content')?.focus();
        }
      })
      .catch(error => {
        reportError(error);
      })
      .finally(() => { popupOpening = false; });
  }

  async function setAddonQuantity(cart, variantId, quantity) {
    let lines = cart.items.filter(item => Number(item.variant_id) === variantId);
    while (lines.length > (quantity > 0 ? 1 : 0)) {
      const line = lines[lines.length - 1];
      cart = await requestJson('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: line.key, quantity: 0 })
      });
      if (!Array.isArray(cart.items) || cart.items.some(item => item.key === line.key)) throw new Error(window.cartStrings.error);
      lines = cart.items.filter(item => Number(item.variant_id) === variantId);
    }
    if (quantity > 0 && lines.length && lines[0].quantity !== quantity) {
      cart = await requestJson('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: lines[0].key, quantity })
      });
    } else if (quantity > 0 && !lines.length) {
      await requestJson('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity })
      });
      cart = await readCart();
    }
    if (!Array.isArray(cart.items)) throw new Error(window.cartStrings.error);
    document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));
    return cart;
  }

  async function applyChoices(checkout) {
    if (operationPending || popupOpening) return;
    operationPending = true;
    const wantsInsurance = Boolean(insuranceCheckbox?.checked);
    const signatureQuantity = signatureCheckbox?.checked ? 1 : 0;
    setBusy(true, checkout);
    try {
      if (window.Shopify?.whenCartChangesComplete) await window.Shopify.whenCartChangesComplete();
      const apply = async () => {
        let cart = await readCart();
        const insuranceQuantity = wantsInsurance ? calculateInsuranceQty(merchandiseTotal(cart)) : 0;
        cart = await setAddonQuantity(cart, SHIPPING_INSURANCE_VARIANT_ID, insuranceQuantity);
        cart = await setAddonQuantity(cart, SIGNATURE_VARIANT_ID, signatureQuantity);
        const quantityOf = id => cart.items.filter(item => Number(item.variant_id) === id).reduce((sum, item) => sum + item.quantity, 0);
        if (quantityOf(SHIPPING_INSURANCE_VARIANT_ID) !== insuranceQuantity || quantityOf(SIGNATURE_VARIANT_ID) !== signatureQuantity ||
            (wantsInsurance && calculateInsuranceQty(merchandiseTotal(cart)) !== insuranceQuantity)) throw new Error(window.cartStrings.error);
        document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));
        return { cart, revision: window.Shopify?.cartMutationRevision };
      };
      const snapshot = window.Shopify?.queueCartMutation ? await window.Shopify.queueCartMutation(apply) : await apply();
      if (checkout) {
        const checkoutButton = document.getElementById('cart-checkout');
        if (!checkoutButton) throw new Error(window.cartStrings.error);
        const cartItems = checkoutButton.closest('cart-items');
        if (typeof cartItems?.checkout === 'function') {
          await cartItems.checkout(snapshot);
          checkoutNavigating = Boolean(cartItems.checkoutPending);
        } else checkoutButton.click();
      } else {
        if (typeof window.refreshOnlineBufferCart === 'function') await window.refreshOnlineBufferCart(snapshot.cart);
        closePopup();
      }
    } catch (error) {
      reportError(error);
    } finally {
      if (!checkoutNavigating) {
        operationPending = false;
        setBusy(false);
      }
    }
  }

  window.addEventListener('pageshow', event => {
    if (!event.persisted || !checkoutNavigating) return;
    checkoutNavigating = false;
    operationPending = false;
    const checkoutButton = document.getElementById('cart-checkout');
    const cartItems = checkoutButton?.closest('cart-items');
    if (cartItems) cartItems.checkoutPending = false;
    if (checkoutButton) checkoutButton.disabled = Boolean(cartItems?.checkTerms && !cartItems.checkTerms.checked);
    setBusy(false);
    closePopup();
  });

  proceedCheckoutButton?.addEventListener('click', event => { event.preventDefault(); applyChoices(true); });
  closePopupButton?.addEventListener('click', event => { event.preventDefault(); applyChoices(false); });
  removeSignatureButton?.addEventListener('click', event => {
    event.preventDefault();
    if (operationPending) return;
    if (signatureCheckbox) signatureCheckbox.checked = false;
    applyChoices(false);
  });

  // -------------------------------------------
  // HELPER FUNCTIONS
  // -------------------------------------------

  // (A) Insurance Calculation
  function calculateInsuranceQty(cartTotal) {
    if (cartTotal <= 100)  return 0;
    if (cartTotal <= 200)  return 1;
    if (cartTotal <= 300)  return 2;
    if (cartTotal <= 400)  return 3;
    if (cartTotal <= 500)  return 4;
    if (cartTotal <= 600)  return 5;
    if (cartTotal <= 700)  return 6;
    if (cartTotal <= 800)  return 7;
    if (cartTotal <= 900)  return 8;
    if (cartTotal <= 1000) return 9;
    if (cartTotal <= 1100) return 10;
    if (cartTotal <= 1200) return 11;
    if (cartTotal <= 1300) return 12;
    if (cartTotal <= 1400) return 13;
    if (cartTotal <= 1500) return 14;
    if (cartTotal <= 1600) return 15;
    if (cartTotal <= 1700) return 16;
    if (cartTotal <= 1800) return 17;
    if (cartTotal <= 1900) return 18;
    if (cartTotal <= 2000) return 19;
    if (cartTotal <= 2100) return 20;
    if (cartTotal <= 2200) return 21;
    if (cartTotal <= 2300) return 22;
    if (cartTotal <= 2400) return 23;
    if (cartTotal <= 2500) return 24;
    if (cartTotal <= 2600) return 25;
    if (cartTotal <= 2700) return 26;
    if (cartTotal <= 2800) return 27;
    if (cartTotal <= 2900) return 28;
    if (cartTotal <= 3000) return 29;
    if (cartTotal <= 3100) return 30;
    if (cartTotal <= 3200) return 31;
    if (cartTotal <= 3300) return 32;
    if (cartTotal <= 3400) return 33;
    if (cartTotal <= 3500) return 34;
    if (cartTotal <= 3600) return 35;
    if (cartTotal <= 3700) return 36;
    if (cartTotal <= 3800) return 37;
    if (cartTotal <= 3900) return 38;
    if (cartTotal <= 4000) return 39;
    if (cartTotal <= 4100) return 40;
    if (cartTotal <= 4200) return 41;
    if (cartTotal <= 4300) return 42;
    if (cartTotal <= 4400) return 43;
    if (cartTotal <= 4500) return 44;
    if (cartTotal <= 4600) return 45;
    if (cartTotal <= 4700) return 46;
    if (cartTotal <= 4800) return 47;
    if (cartTotal <= 4900) return 48;
    if (cartTotal <= 5000) return 49;
    return 50; // Anything above 5000 => 50 (change if you want a different cap)
  }

});
